import { render, staticRenderFns } from "./CreateToken.vue?vue&type=template&id=4e8f9646&"
import script from "./CreateToken.vue?vue&type=script&lang=js&"
export * from "./CreateToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports